<script setup>
import { defineProps, onMounted, ref, defineExpose  } from "vue";
import Password from "@/components/form-fields/password/Index.vue";
import RetypePassword from "@/components/form-fields/retype-password/Index.vue";
import { customerResetByUrl } from '@/hooks/shopify-hooks/api/useLoginApi';
import { QueryParam } from '@/utils/common';
import { useFailMsgBox } from "@/hooks/common/msg-box/useFailMsgBox";
import {
	useCsrFormValidator,
} from "@/hooks/common/useCsrFormValidator";
import { useDispatchGAEvent } from '@/hooks/common/useDispatchGAEvent';

const $emitEvents = defineEmits(["onChange"]);

const props = defineProps({
    stateKey: {
        type: String,
        default: ''
    },
    loginConfig: {
      type: Object,
      default: null
    }
});

const newPasswordInput = ref(null);
const retypePasswordInput = ref(null);
const resetUrl = ref('');
const passwordValue = ref('');
const resValue = ref(null);

onMounted(() => {
  const params = QueryParam.parse(location.search);
  resetUrl.value = params?.resetUrl || '';
  // if (!(resetUrl.value)) {
  //   window.location.href = window.MY_ACCOUNT_CONFIG.homePageUrl;
  // }

})

const passwordChange = (e) => {
  passwordValue.value = e;
}

const submitForm = () => {
  try {
    useCsrFormValidator([newPasswordInput, retypePasswordInput]).then(res => {
      console.log(res)
      resValue.value = res
      const { newPassword, retypePassword } = res
      if (retypePassword !== newPassword) {
        useFailMsgBox(props.loginConfig.resetPWRePWSecurityPrompt, () => {

        });
        return;
      }
      // 进行极验校验
      window.captchaObj && window.captchaObj.showCaptcha && window.captchaObj.showCaptcha();
      // if (newPassword === retypePassword) {
      //   resetCustomerPassword({
      //     password: newPassword,
      //     resetUrl: resetUrl.value
      //   })
      // }
    })
  } catch(e) {
    console.error(e);
  }
  
}

const resetCustomerPassword = async (validateParams) => {
  const { newPassword,retypePassword } = resValue.value;
  if (retypePassword !== newPassword) {return}
  try {
    const res = await customerResetByUrl(newPassword, resetUrl.value,validateParams,props.loginConfig);
    if (res.customerAccessToken) {
      useDispatchGAEvent('__GA_RECOVER_PWT_CLICK__');
      // 调回到登录页面去登录
      $emitEvents("onChange", 'Login');
    }
  } catch(e) {
    console.error(e);
  }
  
}

defineExpose({
  resetCustomerPassword,
});

</script>

<template>
  <div class="csr-login__wrap">
    <div class="csr-login__top">
      <div class="csr-login__title csr-login__title--recover">
        {{ loginConfig.resetPWTitle }}
      </div>
    </div>
  
    <div>
      <form id="csr-shopify-login" @submit.prevent="submitForm">
        <div class="csr-login__form">
          <Password
            ref="newPasswordInput"
            :data-conf="{ label: loginConfig.resetPWPasswordLabel, placeholder: loginConfig.resetPWPasswordPlaceholder, required: true, minlength: '8', name: 'newPassword', defErrorMsg: loginConfig.requiredFieldsPrompt, restrictionHint: loginConfig?.passwordSecurityPrompt }"
            @change="passwordChange"
          />
          <div class="csr-login__form__last-item">
            <RetypePassword
              ref="retypePasswordInput"
              :data-conf="{ label: loginConfig.resetPWRePasswordLabel, placeholder: loginConfig.resetPWRePasswordPlaceholder, required: true, minlength: '8', name: 'retypePassword', defErrorMsg: loginConfig.requiredFieldsPrompt, formatHint: loginConfig.rePWSecurityPrompt, restrictionHint: loginConfig?.rePWSecurityPrompt }"
              :password="passwordValue"
            />
          </div>
        </div>
        <div class="csr-password-box csr-login__btn_not_b2b">
          <button class="csr-login__btn md-button-v2 md-button md-button--primary" type="submit">{{ loginConfig.resetPWConfirmButton }}</button>  
        </div>
      </form>
    </div>
  </div>
</template>